import React from 'react';
import { Focusable } from '../Focusable';
import { Text } from '../Text';
import { Radio } from '../Radio';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet } from '../../utils';
export const Option = ({ isSelected, onSelect, text, style }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(Focusable, { style: [
            styles.container,
            isSelected ? styles.container__isSelected : {},
            style
        ], onPress: onSelect, hoverStyle: styles.container__hover }, ({ hovered }) => (React.createElement(React.Fragment, null,
        React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: [
                styles.text,
                hovered ? styles.text__hover : null,
                isSelected ? styles.text__isSelected : null
            ] }, text),
        React.createElement(Radio, { value: isSelected, onChange: () => { } })))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: size.G,
        paddingVertical: size.I,
        borderWidth: size.A,
        borderColor: color.invert2.p4,
        borderRadius: size.G
    },
    container__isSelected: {
        backgroundColor: color.primary.ghost,
        borderColor: color.primary.solid
    },
    container__hover: {
        backgroundColor: color.invert2.p4
    },
    text: { fontWeight: '500', color: color.invert2.p68, marginRight: size.G },
    text__isSelected: { color: color.primary.solid },
    text__hover: { color: color.invert2.p100 }
}));
//# sourceMappingURL=index.js.map